import type { CSSProperties } from 'react';
import type { SiteContent } from './types';

/**
 * Maps the editable theme palette onto the CSS custom properties that site.css
 * reads (`--ink`, `--orange`, …). Spread onto a wrapper element to scope the
 * palette to that subtree (the public site, or the editor's live preview).
 */
export function themeVars(content: Pick<SiteContent, 'theme'>): CSSProperties {
  const c = content.theme.colors;
  const { typography, layout, buttons } = content.theme;
  const headingFont = typography.heading === 'serif'
    ? "Georgia, 'Times New Roman', serif"
    : typography.heading === 'system'
      ? "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      : "'Bricolage Grotesque', sans-serif";
  const bodyFont = typography.body === 'serif'
    ? "Georgia, 'Times New Roman', serif"
    : typography.body === 'system'
      ? "-apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
      : "'Nunito Sans', sans-serif";
  const buttonRadius = buttons.shape === 'pill' ? '999px' : buttons.shape === 'rounded' ? '12px' : '3px';
  return {
    '--ink': c.ink,
    '--cream': c.cream,
    '--sand': c.sand,
    '--orange': c.orange,
    '--muted': c.muted,
    '--line': c.line,
    '--theme-heading-font': headingFont,
    '--theme-body-font': bodyFont,
    '--theme-content-width': `${layout.contentWidth}px`,
    '--theme-section-spacing': `${layout.sectionSpacing}px`,
    '--theme-radius': `${layout.cornerRadius}px`,
    '--theme-button-radius': buttonRadius,
    '--theme-primary': buttons.tone === 'accent' ? c.orange : c.ink,
  } as CSSProperties;
}
